// import {
//   PPI_NEW_THRESHOLD_DAYS,
//   PPI_UPDATED_THRESHOLD_DAYS
// } from '../../settings';

function getThreshold(offset) {
  const threshold = new Date();
  threshold.setDate(threshold.getDate() - offset);
  return threshold;
}

function getPublishDate(ppsi) {
  const { actualPublishDate } = ppsi;
  return new Date(actualPublishDate);
}

function isPublishedWithin(days, ppsi) {
  const publishDate = getPublishDate(ppsi);
  const thresholdDate = getThreshold(days);
  return publishDate > thresholdDate;
}

function isNewPpi(ppi,dateDuration) {
  const isFirstVersion = ppi.version === 1;
  const isPublishedRecently = isPublishedWithin(dateDuration, ppi);
  return isFirstVersion && isPublishedRecently;
}

function isUpdatedPpi(ppi,dateDuration) {
  const isSecondOrLaterVersion = ppi.version !== 1;
  const isPublishedRecently = isPublishedWithin(
    dateDuration,
    ppi
  );
  return isSecondOrLaterVersion && isPublishedRecently;
}

export { isNewPpi, isUpdatedPpi };
